var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarrierIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4935_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4434 2.87145C10.9947 2.43026 10.0667 2.7118 9.34028 3.43826L7.80769 4.97085C7.5948 5.18375 7.48056 5.2295 7.21056 5.21036L1.86722 4.97837C1.6962 4.96702 1.55162 5.0204 1.43755 5.13448L0.996347 5.57567C0.897528 5.67449 0.928032 5.81891 1.0838 5.87602L5.30913 7.46941L3.59756 9.62202L1.64667 9.04778C1.50225 9.00203 1.37666 9.04389 1.25107 9.16948L1.08783 9.33272C0.988847 9.43171 0.988846 9.56087 1.08783 9.65985L4.65499 13.227C4.75397 13.326 4.8794 13.3223 4.97839 13.2233L5.14195 13.0597C5.26738 12.9343 5.30924 12.8087 5.26738 12.6682L4.69299 10.7171L6.84575 9.00571L8.43914 13.231C8.49236 13.3829 8.64051 13.4172 8.73933 13.3183L9.18069 12.877C9.2946 12.7631 9.34425 12.6147 9.33663 12.4475L9.10091 7.10039C9.0855 6.83411 9.13126 6.71988 9.34415 6.50699L10.8767 4.9744C11.6032 4.24793 11.8808 3.31638 11.4434 2.87145Z",
    fill: "#E80A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4935_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierIcon);
export default __webpack_public_path__ + "static/media/carrier-icon.97f780bce307c1ccfab440d8301d2edc.svg";
export { ForwardRef as ReactComponent };